export const PAGE_LIMIT = 25;

export enum LoginType {
    Local = 'local',
    Google = 'google',
    Yandex = 'yandex',
    VK = 'vk',
}

export enum Role {
    User = 'user',
    Admin = 'admin',
    Broadcaster = 'broadcaster',
    Streamer = 'streamer',
    Payee = 'payee',
}

const toLoginType = (t: string): t is LoginType => Object.values<string>(LoginType).includes(t);
export const toRole = (r: string): r is Role => Object.values<string>(Role).includes(r);

export const filterLoginTypes = (types: string[]): LoginType[] => types.filter(toLoginType);
